import { api } from "../common/http";
const toPage = (res) => res.data;

const TransactionsApi = {
  list: async ({
    page = 0,
    size = 20,
    sort = "createdAt,desc",
    status,
    assignedTo,
    q,
    country,
  } = {}) => {
    const params = { page, size, sort };
    if (assignedTo) params.assignedTo = assignedTo;
    if (Array.isArray(status) && status.length) params.status = status;
    if (q && q.trim()) params.q = q.trim();
    if (country && country.trim()) params.country = country.trim();

    const res = await api.get("/transactions", { params });
    return res.data;
  },

  listByRecipientUuid: async (
    uuid,
    { page = 0, size = 10, sort = "createdAt,desc" } = {}
  ) => {
    const params = { page, size, sort };
    const res = await api.get(`/transactions/by-recipient/uuid/${uuid}`, { params });
    return toPage(res);
  },

  listByRecipientId: async (
    id,
    { page = 0, size = 10, sort = "createdAt,desc" } = {}
  ) => {
    const params = { page, size, sort };
    const res = await api.get(`/transactions/by-recipient/${id}`, { params });
    return toPage(res);
  },

  listBySendertUuid: async (
    uuid,
    { page = 0, size = 10, sort = "createdAt,desc" } = {}
  ) => {
    const params = { page, size, sort };
    const res = await api.get(`/transactions/by-sender/uuid/${uuid}`, { params });
    return toPage(res);
  },

  listBySenderId: async (
    id,
    { page = 0, size = 10, sort = "createdAt,desc" } = {}
  ) => {
    const params = { page, size, sort };
    const res = await api.get(`/transactions/by-sender/${id}`, { params });
    return toPage(res);
  },

  getById: async (id) => (await api.get(`/transactions/${id}`)).data,

  getByUuid: async (uuid) => (await api.get(`/transactions/uuid/${uuid}`)).data,

  create: async (data) => (await api.post("/transactions", data)).data,

  update: async (id, data) => (await api.put(`/transactions/${id}`, data)).data,

  updateStatus: async (id, status) =>
    (await api.patch(`/transactions/${id}/status`, { status })).data,

  remove: async (id) => (await api.delete(`/transactions/${id}`)).data,
};

export default TransactionsApi;
